import { useEffect, useState } from 'react';
import { clientSideEventNames } from '../../../util/uiconstants';

function eventName(id) {
    return clientSideEventNames.resetTimer + "_" + id;
}

export function resetTimer(id) {
    window.dispatchEvent(new CustomEvent(eventName(id)));
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
///BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE BAD PRACTICE///
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//Do not use it unless it is explicitly asked on AC.

export default function Timer(props) {
    const { id, seconds } = props;

    // Initialize state variables for timer and timeInterval
    const [timer, setTimer] = useState(0);
    const [timeInterval, setTimeInterval] = useState(null);

    // Function to start the timer
    const startTimer = () => {
        // Use setInterval to update the timer every 1000 milliseconds (1 second)
        setTimeInterval(setInterval(() => {
            // Update the timer by incrementing the previous value by 1
            setTimer((prev) => prev + 1);
        }, seconds * 1000));
    }

    // Function to reset the timer
    const resetTimer = () => {
        // Reset the timer value to 0
        setTimer(0);
        // Clear the interval to stop the timer
        clearInterval(timeInterval);
    }

    useEffect(() => {
        startTimer();
        window.addEventListener(eventName(id), resetTimer);
        return () => {
            window.removeEventListener(eventName(id), resetTimer);
        }
    }, [])

    if(timer === seconds){
        window.dispatchEvent(new CustomEvent(id));
    }

    return;
}